<template>
    <div class="business-card" :class="{ flipped: flipped || flipset === 2 }" @click="handleClick">
        <div class="business-card-inside">
            <div class="flip-card-front"><slot name="front"></slot></div>
            <div class="flip-card-back"><slot name="back"></slot></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BusinessCard",
        props: {
            flipped: {
                type: Boolean,
                default: () => false
            },
            flipset: {
                type: Number,
                default: () => 0,
                validator: (v) => [0, 1, 2].includes(v)
            }
        },
        data () {
            return {

            } 
        },
        computed: {

        },
        methods: {
            handleClick () {
                if (this.flipset === 0) {
                    this.$emit('update:flipped', !this.flipped)
                }
            }
        },
        mounted () {

        }  
    }
</script>

<style scoped lang="scss">
    .business-card {
        cursor: pointer;
        height: 0;
        padding-top: 286px / 500px * 100%;
        background: white;
        position: relative;
        margin: 3px auto;
        perspective: 1000px;
    }

    .business-card-inside {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: transform 0.8s;
        transform-style: preserve-3d;
        box-shadow: 0px 1px 4px 2px rgba(0, 0, 0, 0.09);
    }

    .business-card.flipped .business-card-inside {
        transform: rotateY(180deg);
    }

    .flip-card-front, .flip-card-back {
        background: whitesmoke;
        background-image: url('https://brandonaguirre-website-images.s3.us-east-2.amazonaws.com/business-card.png');
        background-repeat: no-repeat;
        background-size: cover;
        padding: 10px;
        position: absolute;
        width: calc(100% - 20px);
        height: calc(100% - 20px);
        -webkit-backface-visibility: hidden; /* Safari */
        backface-visibility: hidden;
        overflow: hidden;
    }

/* Style the front side (fallback if image is missing) */
    .flip-card-front {

    }

/* Style the back side */
    .flip-card-back {

        transform: rotateY(180deg);
    }
</style>